(() => {
  if (window.__sunglassUpGiftServiceV3Initialized) return;
  window.__sunglassUpGiftServiceV3Initialized = true;

  const VARIANT_ID = 55438146208073;

  const SECTION_IDS = [
    'cart-items',
    'cart-footer',
    'cart-item-count',
    'cart-live-region'
  ];

  let cleanupInFlight = false;

  function root() {
    return window.Shopify?.routes?.root || '/';
  }

  async function getCart() {
    const response = await fetch(`${root()}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Impossibile leggere la Shopping Bag.');
    }

    return response.json();
  }

  function findGift(cart) {
    return (cart.items || []).find(
      item => Number(item.variant_id) === VARIANT_ID
    );
  }

  /*
   * Gli articoli tecnici SunglassUp non devono mantenere in vita
   * Gift Packaging da soli. Care Kit possiede già la propria
   * dependency/orphan logic.
   */
  function isTechnicalService(item) {
    if (Number(item.variant_id) === VARIANT_ID) return true;

    const title = String(
      item.product_title || item.title || ''
    ).toLowerCase();

    const handle = String(
      item.handle || item.url || ''
    ).toLowerCase();

    return (
      title.includes('sunglassup care kit') ||
      handle.includes('sunglassup-care-kit')
    );
  }

  function hasRealMerchandise(cart) {
    return (cart.items || []).some(
      item => !isTechnicalService(item)
    );
  }

  async function cartRequest(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...payload,
        sections: SECTION_IDS,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok || data.status === 422) {
      throw new Error(
        data.description ||
        data.message ||
        'Impossibile aggiornare Gift Packaging.'
      );
    }

    if (!data.sections) {
      throw new Error(
        'Shopify ha aggiornato il carrello ma non ha restituito le sezioni del drawer.'
      );
    }

    return data;
  }

  function dispatchUpdate(response) {
    document.body.dispatchEvent(
      new CustomEvent('baseline:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response,
          originalTarget: null
        }
      })
    );
  }

  function setLoading(container, button, loading) {
    container?.classList.toggle('is-loading', loading);

    if (button) {
      button.disabled = loading;
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  function showError(container, message = '') {
    const error =
      container?.querySelector('[data-gift-packaging-error]');

    if (!error) return;

    error.textContent = message;
    error.hidden = !message;
  }

  async function addGift() {
    const cart = await getCart();

    if (!hasRealMerchandise(cart)) {
      throw new Error(
        'Aggiungi prima un articolo alla Shopping Bag.'
      );
    }

    const existingGift = findGift(cart);

    /* Massimo una confezione regalo per ordine. */
    if (existingGift) {
      return cartRequest(`${root()}cart/change.js`, {
        id: existingGift.key,
        quantity: 1
      });
    }

    return cartRequest(`${root()}cart/add.js`, {
      items: [
        {
          id: VARIANT_ID,
          quantity: 1
        }
      ]
    });
  }

  async function removeGiftByKey(itemKey) {
    return cartRequest(`${root()}cart/change.js`, {
      id: itemKey,
      quantity: 0
    });
  }

  async function removeGift(button) {
    let itemKey = button?.dataset?.itemKey;

    if (!itemKey) {
      const cart = await getCart();
      itemKey = findGift(cart)?.key;
    }

    if (!itemKey) {
      throw new Error(
        'Gift Packaging non è presente nella Shopping Bag.'
      );
    }

    return removeGiftByKey(itemKey);
  }

  async function handleGift(button) {
    const container =
      button.closest('[data-gift-packaging]');

    if (!container || button.disabled) return;

    setLoading(container, button, true);
    showError(container);

    try {
      const cart = await getCart();
      const gift = findGift(cart);

      const response = gift
        ? await removeGift(button)
        : await addGift();

      dispatchUpdate(response);
    } catch (error) {
      showError(
        container,
        error?.message ||
        'Impossibile aggiornare Gift Packaging.'
      );

      console.error(
        'SunglassUp Gift Service:',
        error
      );
    } finally {
      setLoading(container, button, false);
    }
  }

  /*
   * Dependency:
   * se nel carrello restano soltanto servizi tecnici SunglassUp,
   * Gift Packaging viene rimosso automaticamente.
   */
  async function cleanupOrphanGift() {
    if (cleanupInFlight) return;

    cleanupInFlight = true;

    try {
      const cart = await getCart();
      const gift = findGift(cart);

      if (!gift || hasRealMerchandise(cart)) return;

      const response = await removeGiftByKey(gift.key);
      dispatchUpdate(response);
    } catch (error) {
      console.error(
        'SunglassUp Gift Service dependency:',
        error
      );
    } finally {
      cleanupInFlight = false;
    }
  }

  /*
   * Capture phase: necessario nel drawer Alpine/Teleport.
   */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const button =
        target.closest('[data-gift-packaging-toggle]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      handleGift(button);
    },
    true
  );

  function scheduleCleanup() {
    window.setTimeout(cleanupOrphanGift, 0);
  }

  window.addEventListener(
    'baseline:cart:afteradditem',
    scheduleCleanup
  );

  window.addEventListener(
    'baseline:cart:cartqtychange',
    scheduleCleanup
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleCleanup
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleCleanup,
      { once: true }
    );
  } else {
    scheduleCleanup();
  }
})();